import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class WorkerService {

	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {put} /v2/Authentication/Worker/Password Change Worker Password
	 * @apiName changePassword
	 * @apiGroup Authentication
	 * @apiVersion 20.0.0
	 */
	changePassword(data) {
		return this._http.put<any>(`${environment.apiUrl}/v2/Authentication/Worker/Password`, data);
	}

	/**
	 * @api {get} /v2/Workers/AssociatedDrivers Get Associated Drivers
	 * @apiName getAssociatedDrivers
	 * @apiGroup Workers
	 * @apiVersion 20.0.0
	 */
	getAssociatedDrivers() {
		return this._http.get<any>(`${environment.apiUrl}/v2/Workers/AssociatedDrivers`);
	}

	/**
	 * @api {get} /v2/HumanResources/CurrentUser Get Human Resource Profile
	 * @apiName getHumanResourceProfile
	 * @apiGroup HumanResources
	 * @apiVersion 20.0.0
	 */
	getHumanResourceProfile() {
		return this._http.get<any>(`${environment.apiUrl}/v2/HumanResources/CurrentUser`);
	}

	/**
	 * @api {get} /v2/Workers/:id Get Worker Profile
	 * @apiName getWorkerProfile
	 * @apiGroup Workers
	 * @apiVersion 20.0.0
	 */
	getWorkerProfile(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Workers/${id}`);
	}

	/**
	 * @api {patch} /v2/Workers/:id Update Worker Profile
	 * @apiName updateWorkerProfile
	 * @apiGroup Workers
	 * @apiVersion 20.0.0
	 */
	updateWorkerProfile(id, patch) {
		return this._http.patch<any>(`${environment.apiUrl}/v2/Workers/${id}`, patch);
	}
}
